import { render, staticRenderFns } from "./COP.vue?vue&type=template&id=4d2d73b9&scoped=true"
import script from "./COP.vue?vue&type=script&lang=js"
export * from "./COP.vue?vue&type=script&lang=js"
import style0 from "./COP.vue?vue&type=style&index=0&id=4d2d73b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2d73b9",
  null
  
)

export default component.exports